/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BenefitsChartMobile_viewer$ref = any;
type BenefitsChart_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LoyaltyModulesWrapper_viewer$ref: FragmentReference;
export type LoyaltyModulesWrapper_viewer = {|
  +$fragmentRefs: BenefitsChart_viewer$ref & BenefitsChartMobile_viewer$ref,
  +$refType: LoyaltyModulesWrapper_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LoyaltyModulesWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BenefitsChart_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BenefitsChartMobile_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '15825029cedec988d6bed74635b65a7b';
module.exports = node;
